import { initialWarehouseState, IWarehouseState } from '../state/warehouse.state';
import { WarehouseAction, EWarehouseActions } from '../actions/warehouse.action'


export function warhouseReducers(state = initialWarehouseState, action: WarehouseAction):IWarehouseState{

    switch (action.type) {

        case EWarehouseActions.CreateReleaseMaterialProductsSuccess: {
            return {
                ...state,
                getReleaseMaterialProductsSuccess: action.payload,
                getReleaseMaterialProductsError: null
            };
        }
        case EWarehouseActions.CreateReleaseMaterialProductsError: {
            return {
                ...state,
                getReleaseMaterialProductsError: action.payload,
                getReleaseMaterialProductsSuccess: null
            };
        }
        case EWarehouseActions.GetReceiveProductsSuccess: {
            return {
                ...state,
                getReceiveProductSuccess: action.payload,
                getReceiveProductError: null
            };
        }
        case EWarehouseActions.GetReceiveProductsError: {
            return {
                ...state,
                getReceiveProductError: action.payload,
                getReceiveProductSuccess: null
            };
        }
        case EWarehouseActions.GetEditReceiveProductSuccess: {
            return {
                ...state,
                getEditReceiveProductSuccess: action.payload,
                getEditReceiveProductError: null
            };
        }
        case EWarehouseActions.GetEditReceiveProductError: {
            return {
                ...state,
                getEditReceiveProductError: action.payload,
                getEditReceiveProductSuccess: null
            };
        }
        //reject material
        case EWarehouseActions.GetAllRejectMaterialsSuccess: {
            return {
                ...state,
                getAllRejectMaterialSuccess: action.payload,
                getAllRejectMaterialError: null
            };
        }
        case EWarehouseActions.GetAllRejectMaterialsError: {
            return {
                ...state,
                getAllRejectMaterialError: action.payload,
                getAllRejectMaterialSuccess: null
            };
        }
        case EWarehouseActions.GetAddRejectMaterialSuccess: {
            return {
                ...state,
                getAddRejectMaterialSuccess: action.payload,
                getAddRejectMaterialError: null
            };
        }
        case EWarehouseActions.GetAddRejectMaterialError: {
            return {
                ...state,
                getAddRejectMaterialError: action.payload,
                getAddRejectMaterialSuccess: null
            };
        }
        case EWarehouseActions.GetAddRejectProductSuccess: {
            return {
                ...state,
                getAddRejectProductSuccess: action.payload,
                getAddRejectProductError: null
            };
        }
        case EWarehouseActions.GetAddRejectProductError: {
            return {
                ...state,
                getAddRejectProductError: action.payload,
                getAddRejectProductSuccess: null
            };
        }
        case EWarehouseActions.GetEditRejectMaterial_productSuccess: {
            return {
                ...state,
                getEditRejectMaterial_productSuccess: action.payload,
                getEditRejectMaterial_productError: null
            };
        }
        case EWarehouseActions.GetEditRejectMaterial_productError: {
            return {
                ...state,
                getEditRejectMaterial_productError: action.payload,
                getEditRejectMaterial_productSuccess: null
            };
        }
        case EWarehouseActions.GetMlosSuccess: {
            return {
                ...state,
                getMlosSuccess: action.payload,
                getMlosError: null
            };
        }
        case EWarehouseActions.GetMlosError: {
            return {
                ...state,
                getMlosError: action.payload,
                getMlosSuccess: null
            };
        }
        case EWarehouseActions.GetRecLotsByMaterialIDSuccess: {
            return {
                ...state,
                getRecLotsByMaterialIDSuccess: action.payload,
                getRecLotsByMaterialIDError: null
            };
        }
        case EWarehouseActions.GetRecLotsByMaterialIDError: {
            return {
                ...state,
                getRecLotsByMaterialIDError: action.payload,
                getRecLotsByMaterialIDSuccess: null
            };
        }
        case EWarehouseActions.GetRecLotsByMaterialIDListSuccess: {
            return {
                ...state,
                getRecLotsByMaterialIDListSuccess: action.payload,
                getRecLotsByMaterialIDError: null
            };
        }
        case EWarehouseActions.GetRecLotsByMaterialIDListError: {
            return {
                ...state,
                getRecLotsByMaterialIDListError: action.payload,
                getRecLotsByMaterialIDListSuccess: null
            };
        }
       //return material
        case EWarehouseActions.GetAddReturnMaterialSuccess: {
            return {
                ...state,
                getAddReturnMaterialSuccess: action.payload,
                getAddReturnMaterialError: null
            };
        }
        case EWarehouseActions.GetAddReturnMaterialError: {
            return {
                ...state,
                getAddReturnMaterialError: action.payload,
                getAddReturnMaterialSuccess: null
            };
        }
        case EWarehouseActions.GetEditReturnMaterialSuccess: {
            return {
                ...state,
                getEditReturnMaterialSuccess: action.payload,
                getEditReturnMaterialError: null
            };
        }
        case EWarehouseActions.GetEditReturnMaterialError: {
            return {
                ...state,
                getEditReturnMaterialError: action.payload,
                getEditReturnMaterialSuccess: null
            };
        }
        case EWarehouseActions.GetRecProductsByFormulaIDSuccess: {
            return {
                ...state,
                getReceiveProductByFormulaIdSuccess: action.payload,
                getReceiveProductByFormulaIdError: null
            };
        }
        case EWarehouseActions.GetRecProductsByFormulaIDError: {
            return {
                ...state,
                getReceiveProductByFormulaIdError: action.payload,
                getReceiveProductByFormulaIdSuccess: null
            };
        }

        case EWarehouseActions.GetUpdateSohValueSuccess: {
            return {
                ...state,
                getUpdateSohValueSuccess: action.payload,
                getUpdateSohValueError: null
            };
        }
        case EWarehouseActions.GetUpdateSohValueError: {
            return {
                ...state,
                getUpdateSohValueError: action.payload,
                getUpdateSohValueSuccess: null
            };
        }
        case EWarehouseActions.GetReceivedQtyByFormulaIdSuccess: {
            return {
                ...state,
                getReceivedQtyByFormulaIdSuccess: action.payload,
                getReceivedQtyByFormulaIdError: null
            };
        }
        case EWarehouseActions.GetReceivedQtyByFormulaIdError: {
            return {
                ...state,
                getReceivedQtyByFormulaIdError: action.payload,
                getReceivedQtyByFormulaIdSuccess: null
            };
        }
        case EWarehouseActions.GetMiscellaneousReasonsSuccess: {
            return {
                ...state,
                getMiscellaneousReasonsError: null,
                getMiscellaneousReasonsSuccess: action.payload
            };
        }
        case EWarehouseActions.GetMiscellaneousReasonsError: {
            return {
                ...state,
                getMiscellaneousReasonsError: action.payload,
                getMiscellaneousReasonsSuccess:null            };
        }
        case EWarehouseActions.AddMiscellaneousReasonSuccess: {
            return {
                ...state,
                addMiscellaneousReasonError:null,
                addMiscellaneousReasonSuccess: action.payload,            };
        }
        case EWarehouseActions.AddMiscellaneousReasonError: {
            return {
                ...state,
                addMiscellaneousReasonError:action.payload,
                addMiscellaneousReasonSuccess: null,            };
        }
        default: {
            return state;
          }
    }

}
